import { PerformedByRequestDTO } from './performed-by-request-dto';

export interface ReadUserContextRoleProfileRequestDTO extends PerformedByRequestDTO {
    userRoleContextProfileId?: number;
    languageCd?: string;
}
